import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchFaqs } from "../redux/actions/faqs";
import PageTitle from "../components/custom/PageTitle";
import FAQsSkeleton from "../components/custom/skeletonLoader/FAQsSkeleton";

function FAQs() {
  const dispatch = useDispatch();
  const { items: faqs, status, error } = useSelector((state) => state.faqs);
  const [activeAccordions, setActiveAccordions] = useState({});

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchFaqs());
    }
  }, [status, dispatch]);

  useEffect(() => {
    if (faqs.length > 0) {
      const initialActiveState = {
        0: true,
        [Math.ceil(faqs.length / 2)]: true,
      };
      setActiveAccordions(initialActiveState);
    }
  }, [faqs]);

  const toggleAccordion = (index) => {
    setActiveAccordions((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const Accordion = ({ question, answer, index }) => (
    <li
      className={`accordion block ${
        activeAccordions[index] ? "active-block" : ""
      }`}
    >
      <div
        className={`acc-btn ${activeAccordions[index] ? "active" : ""}`}
        onClick={() => toggleAccordion(index)}
      >
        <div className="icon-box"></div>
        <h4>{question}</h4>
      </div>
      {activeAccordions[index] && (
        <div className="acc-content current">
          <div className="text">
            <p>{answer}</p>
          </div>
        </div>
      )}
    </li>
  );

  if (status === "loading") {
    return <FAQsSkeleton />;
  }

  if (status === "failed" && error) {
    return (
      <div className="w-100 h-33 my-5">
        <div className="bg-white py-5">
          <div className="container">
            <div className="d-flex w-100 rounded border-start border-danger border-5 bg-light p-4">
              <div className="me-3 text-danger">
                <svg
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                  className="fill-current"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.9999 2.83366C9.57774 2.83366 3.83325 8.57815 3.83325 16.0003C3.83325 23.4225 9.57774 29.167 16.9999 29.167C24.4221 29.167 30.1666 23.4225 30.1666 16.0003C30.1666 8.57815 24.4221 2.83366 16.9999 2.83366ZM0.333252 16.0003C0.333252 7.54021 7.53979 0.33366 15.9999 0.33366C24.46 0.33366 31.6666 7.54021 31.6666 16.0003C31.6666 24.4604 24.46 31.667 15.9999 31.667C7.53979 31.667 0.333252 24.4604 0.333252 16.0003ZM17.8333 8.83366C17.8333 8.18138 17.3182 7.66699 16.6666 7.66699C16.0143 7.66699 15.4999 8.18138 15.4999 8.83366V18.0846C15.4999 18.7369 16.0143 19.2513 16.6666 19.2513C17.3182 19.2513 17.8333 18.7369 17.8333 18.0846V8.83366ZM16.6666 24.5003C17.3182 24.5003 17.8333 23.9859 17.8333 23.3337C17.8333 22.6814 17.3182 22.167 16.6666 22.167C16.0143 22.167 15.4999 22.6814 15.4999 23.3337C15.4999 23.9859 16.0143 24.5003 16.6666 24.5003Z"
                  ></path>
                </svg>
              </div>
              <div className="w-100 mb-3">
                <div className="mb-2 d-flex align-items-center justify-content-between">
                  <h5 className="fs-5 fw-medium text-danger">
                    {error.message || "An error occurred"}
                  </h5>
                </div>
                <p className="text-body">Please try again later.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Filter approved FAQs
  const approvedFaqs = faqs.filter((faq) => faq.status === "approve");

  if (approvedFaqs.length === 0) {
    return (
      <div>
        <h1>No approved FAQs available.</h1>
      </div>
    );
  }

  return (
    <div className="boxed_wrapper ltr">
      <PageTitle
        title="General FAQs"
        breadcrumbs={[{ text: "Home", link: "/" }, { text: "FAQs" }]}
      />

      <section className="faq-section pt_120 pb_100">
        <div className="auto-container">
          <div className="sec-title centred mb_70">
            {/* <h6>Regular FAQs</h6> */}
            <h2>Frequently Asked Questions</h2>
          </div>
          <div className="row clearfix">
            <div className="col-lg-6 col-md-12 col-sm-12 accordion-column">
              <ul className="accordion-box">
                {approvedFaqs
                  .slice(0, Math.ceil(approvedFaqs.length / 2))
                  .map((faq, index) => (
                    <Accordion key={faq._id} {...faq} index={index} />
                  ))}
              </ul>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 accordion-column">
              <ul className="accordion-box">
                {approvedFaqs
                  .slice(Math.ceil(approvedFaqs.length / 2))
                  .map((faq, index) => (
                    <Accordion
                      key={faq._id}
                      {...faq}
                      index={index + Math.ceil(approvedFaqs.length / 2)}
                    />
                  ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default FAQs;
